import { useCallback, useEffect } from 'react';

import { Typography } from 'antd';

import HorizontalList from '@/components/shared/HorizontalList';
import { useRefetchWhenReachEnd } from '@/hooks/useRefetchWhenReachEnd';
import { useSocketShouldUpdateCourses } from '@/hooks/useSocketUpdateCourses';
import { IMyCourse } from '@/interfaces/course';
import { IPaginationParams } from '@/interfaces/pagination';
import { coursesApi } from '@/services/course';
import styled, { StyledProp } from '@/styled';

import Card from '../Card';

const MyCourses = ({ className }: StyledProp) => {
  const update = useSocketShouldUpdateCourses();

  const [refetch, data] = coursesApi.endpoints.getCourses.useLazyQuery();
  const { data: response, isFetching, isUninitialized } = data;

  const onReachedEnd = useCallback(
    (params: IPaginationParams) => {
      refetch(params);
    },
    [refetch]
  );

  useRefetchWhenReachEnd<IMyCourse[]>({ ...data, onReachedEnd });

  useEffect(() => {
    refetch({ page: 1, size: 20, hasParams: false });
  }, [update, refetch]);

  if (!isUninitialized && response?.total_rows === 0) return null;

  return (
    <div className={className}>
      <Typography.Title level={4} className='courses-title'>
        Todos os Cursos
      </Typography.Title>
      <HorizontalList
        isFetching={isFetching}
        isPaginated={true}
        pagination={{
          totalRows: response?.total_rows,
          totalPages: response?.total_pages,
          pageSize: response?.page.size,
          page: response?.page.page
        }}
        marginTop={24}
      >
        {response?.data.map(course => (
          <Card {...course} key={course.id} />
        ))}
      </HorizontalList>
    </div>
  );
};

export default styled(MyCourses)`
  .moreInfo {
    width: calc(100% - 16px);
    z-index: 3;
  }
`;
